import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable()
export class UnauthorizedResponseInterceptor implements HttpInterceptor {
  constructor(private router: Router, private authService: AuthService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // A 401 from the login request itself means "wrong credentials" and must reach
    // the login page so it can show the error and re-enable the form. Only treat a
    // 401 as an expired session (logout + redirect) for non-login requests.
    const isLoginRequest = request.url.includes('/account/login');

    return next.handle(request).pipe(
      catchError((err) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401 && !isLoginRequest) {
            this.authService.logout();
            this.router.navigate(['account', 'login']);
            return EMPTY;
          }
        }
        return throwError(() => err);
      })
    );
  }
}
